import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import { Logout, NotificationsActive } from "@mui/icons-material";
import color from "../../Constants/colors";
import { useTranslation } from "react-i18next";

interface MaintenanceOverlayProps {
  onLogout: () => void;
}

const MaintenanceOverlay = ({ onLogout }: MaintenanceOverlayProps) => {
  const { t } = useTranslation("dashboardLayout");

  return (
    <>
      {/* Orange banner at the very top */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          backgroundColor: color.accent,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: 2.5,
          zIndex: 1201,
        }}
      >
        {/* Logo on the left */}
        <Box
          sx={{
            position: "absolute",
            left: 16,
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src="/commo_logo.png"
            alt="Logo"
            style={{ maxHeight: "28px", filter: "brightness(0) invert(1)" }}
          />
        </Box>

        {/* Centered maintenance text */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <BuildIcon sx={{ color: color.white, fontSize: "1.2rem" }} />
          <Typography
            sx={{
              color: color.white,
              fontWeight: 600,
              fontSize: { xs: "0.85rem", sm: "1rem" },
              letterSpacing: "0.5px",
            }}
          >
            {t("dashboardLayout.maintenanceBanner")}
          </Typography>
        </Box>

        {/* Release notes & logout on the right */}
        <Box
          sx={{
            position: "absolute",
            right: 16,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <Tooltip title={t("dashboardLayout.logoutTooltip")}>
            <IconButton onClick={onLogout} size="small">
              <Logout sx={{ color: color.white, fontSize: "1.3rem" }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>

      {/* Semi-transparent overlay - allows scroll but blocks clicks */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          zIndex: 1200,
          backgroundColor: "rgba(255, 255, 255, 0.35)",
          pointerEvents: "auto",
        }}
      />
    </>
  );
};

export default MaintenanceOverlay;
